module.exports = __webpack_public_path__ + "static/media/miami-26.d87d9751.jpg";